import { render, staticRenderFns } from "./FeDialogBtn.vue?vue&type=template&id=673ea802&scoped=true&"
import script from "./FeDialogBtn.vue?vue&type=script&lang=js&"
export * from "./FeDialogBtn.vue?vue&type=script&lang=js&"
import style0 from "./FeDialogBtn.vue?vue&type=style&index=0&id=673ea802&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ea802",
  null
  
)

export default component.exports